<div class="banner free-shipping">
  <p>Free shipping on orders $50+! *</p>
</div>  

<style>
  * {
    font-family: "gotham-book";
    letter-spacing: 0;
  }
  .banner.free-shipping {
    font-size: 0.8125rem;
    text-transform: uppercase;
    display: flex;
    gap: 50px;
    justify-content: center;
    background-color: var(--freeShipping);
    color: #fff;
    box-sizing: content-box;
    font-weight: 400;
    letter-spacing: 0.11em;
    height: 34px;
    align-items: center;
    padding: 0 20px;
    position: relative;
    z-index: 1;
  }
  p {
    text-align: center;
  }

</style>
